import {List, Record} from 'immutable';

const State = Record({

  new_favorites: List(),

});

const engage = (state = new State(), action) => {

  switch (action.type) {


    case 'SET_NEW_FAVORITES':
      return state.set('new_favorites', action.value);


    default:
      return state;
  }
};


export default engage;


// WEBPACK FOOTER //
// ./src/reducers/engage-reducer.js